import * as React from 'react';
import cn from 'classnames';

export type TextareaProps =
	React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
		label?: string;
		description?: string;
		showCounter?: boolean;
		hasError?: boolean;
	};

const Textarea = ({
	value,
	label,
	hasError,
	description,
	showCounter = false,
	maxLength,
	required,
	...props
}: TextareaProps): React.ReactElement => {
	const textLength = typeof value === 'string' && value.length;

	return (
		<label className="flex flex-col">
			<div
				className={cn('flex justify-between items-center', {
					'mb-2': label || required,
				})}
			>
				<span className="text-base font-semibold text-neutral-700">
					{label}
				</span>
				{required && (
					<span className="text-xs font-normal text-accent-600">
						Required
					</span>
				)}
			</div>
			<textarea
				value={value}
				required={required}
				maxLength={maxLength}
				className={cn(
					'border-2 text-base font-semibold text-neutral-700 bg-white rounded px-4 py-2 peer mb-2 outline-none',
					'placeholder:text-neutral-400 placeholder:font-normal',
					'disabled:bg-neutral-100 disabled:font-normal disabled:text-neutral-500',
					'focus:shadow',
					{
						'border-error-500': hasError,
						'border-neutral-300 focus:border-primary-400':
							!hasError,
					}
				)}
				{...props}
			/>
			<span className="flex justify-between text-xs text-neutral-500">
				{description && <p>{description}</p>}
				{showCounter && (
					<p className={description ? 'ml-2' : ''}>
						{textLength}
						{maxLength ? `/${maxLength}` : null}
					</p>
				)}
			</span>
		</label>
	);
};

export default Textarea;
